// Catalogue complet des profils et services — MON DESSINATEUR BTP

export const OWNER = {
  name: "MON DESSINATEUR BTP",
  email: "contact@mon-dessinateur-btp.fr",
  phone: "07 63 98 63 30",
  address: "2 rue de Courcy, Épinal, France",
  coverage: "Toute la France",
  tagline: "Dessinateur BTP indépendant — plans techniques, DOE, BIM",
};

// helper
const s = (id, name, min, max, unit = null) => ({ id, name, min, max, unit });

export const PROFILES = [
  {
    id: "entreprise_btp",
    title: "Entreprise BTP",
    subtitle: "Exécution, coffrage, ferraillage",
    image: "https://images.pexels.com/photos/8159/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    services: [
      s("exec", "Plans d'exécution", 500, 800),
      s("coff", "Plans de coffrage / ferraillage", 600, 1000),
      s("chantier", "Plans de chantier", 300, 400),
      s("details_ent", "Détails techniques", 100, 300, "unité"),
      s("doe_ent", "DOE", 400, 600),
      s("reserv", "Plans de réservations", 200, 400),
      s("maj_travaux", "Mises à jour après travaux", 300, 600),
      s("metres", "Métrés", 500, 800),
      s("memoire_tech", "Mémoire technique", 400, 500),
    ],
  },
  {
    id: "bureau_etudes",
    title: "Bureau d'études",
    subtitle: "Structure, fluides, schémas",
    image: "https://images.unsplash.com/photo-1774600166818-e554a4d4c376?crop=entropy&cs=srgb&fm=jpg&q=85",
    services: [
      s("mep_calculs", "Mise au propre des calculs en plans", 600, 900),
      s("plans_structure", "Plans structure", 800, 1000),
      s("cvc", "Plans CVC / plomberie / électricité", 1000, 1500),
      s("schemas", "Schémas techniques", 300, 500),
      s("coupes_fac", "Coupes / façades", 400, 500, "unité"),
      s("notes_g", "Notes graphiques", 300, 500),
    ],
  },
  {
    id: "cabinet_architecture",
    title: "Cabinet d'architecture",
    subtitle: "APS, APD, PC, DCE, rendus",
    image: "https://images.pexels.com/photos/34573691/pexels-photo-34573691.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    services: [
      s("aps_apd", "Plans APS / APD / PC / DCE", 1000, 1500),
      s("pc", "Plans de permis de construire", 500, 800),
      s("amgt", "Plans d'aménagement intérieur", 300, 600),
      s("facades", "Façades", 400, 500, "unité"),
      s("coupes", "Coupes", 400, 500, "unité"),
      s("details_arch", "Détails techniques", 100, 300, "unité"),
      s("rendus", "Rendus 2D / 3D", 100, 300),
    ],
  },
  {
    id: "maitre_oeuvre",
    title: "Maître d'œuvre",
    subtitle: "Consultation, synthèse, DOE",
    image: "https://images.unsplash.com/photo-1759922378219-1d31edb644f4?crop=entropy&cs=srgb&fm=jpg&q=85",
    services: [
      s("conso_ent", "Plans de consultation entreprises", 2000, 2500),
      s("modifs", "Modifications en cours de chantier", 800, 1000),
      s("synthese", "Synthèse technique", 400, 800),
      s("doe_mo", "DOE", 400, 600),
      s("suivi_doc", "Suivi documentaire graphique", 400, 600),
    ],
  },
  {
    id: "maitre_ouvrage",
    title: "Maître d'ouvrage",
    subtitle: "Présentation, vente, rénovation",
    image: "https://images.unsplash.com/photo-1774600166379-d70791dd8ea1?crop=entropy&cs=srgb&fm=jpg&q=85",
    services: [
      s("presentation", "Plans de présentation projet", 500, 1000),
      s("vente", "Plans de vente", 1000, 2000),
      s("releves", "Relevés existants", 1000, 2000),
      s("renov", "Plans rénovation", 1000, 1500),
      s("viz3d", "Visualisations 3D", 300, 600),
      s("dossier_simpl", "Dossier technique simplifié", 400, 600),
    ],
  },
  {
    id: "geometre",
    title: "Géomètre",
    subtitle: "Relevés, plans existants",
    image: "https://images.unsplash.com/photo-1766830110938-0ea8a6d78ecb?crop=entropy&cs=srgb&fm=jpg&q=85",
    services: [
      s("releves_geo", "Relevés existants", 1000, 2000),
      s("mep_calculs_geo", "Mise au propre des calculs en plans", 600, 900),
      s("details_geo", "Détails techniques", 100, 300, "unité"),
    ],
  },
  {
    id: "bureau_controle",
    title: "Bureau de contrôle",
    subtitle: "PMR, incendie, sécurité",
    image: "https://images.unsplash.com/photo-1523705480679-b5d0cc17a656?crop=entropy&cs=srgb&fm=jpg&q=85",
    services: [
      s("maj_rem", "Mise à jour plans suite remarques", 200, 500),
      s("pmr", "Conformité PMR / incendie", 500, 800),
      s("securite", "Plans sécurité", 600, 1000),
      s("reglem", "Dossiers graphiques réglementaires", 400, 600),
    ],
  },
  {
    id: "bim_manager",
    title: "BIM Manager / Coordinateur",
    subtitle: "Revit, Archicad, DOE numérique",
    image: "https://images.unsplash.com/photo-1776090893591-90f5ea3fa523?crop=entropy&cs=srgb&fm=jpg&q=85",
    services: [
      s("revit", "Modélisation Revit / Archicad", 1500, 2500),
      s("familles", "Création familles BIM", 1000, 1500),
      s("conflits", "Détection conflits", 1000, 1500),
      s("extraction", "Extraction plans depuis maquette", 600, 800),
      s("doe_num", "DOE numérique", 800, 1000),
      s("maj_maquette", "Mise à jour maquette", 500, 800),
    ],
  },
];

export const getProfile = (id) => PROFILES.find((p) => p.id === id);
